module.exports = __webpack_public_path__ + "static/img/Three of Wands.55c25b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Three of Wands.jpg
// module id = 1328
// module chunks = 0